import { useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchEmployerExternalJobBoard } from "../../../redux/actions/company_action";
import content_my from "./content_my.json";
import content_sg from "./content_sg.json";
import {
  BoxContainer,
  BoxStyled,
  ImageStyled,
  SectionContainer,
  TextStyled,
} from "./styles";

function EmployerLandingAggregator(props) {
  const isDesktop = useMediaQuery("(max-width:1280px)");
  const isTablet = useMediaQuery("(max-width:768px)");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchEmployerExternalJobBoard());
  }, []);

  // const externalJBList = useSelector(
  //   (state) => state?.companies?.externalJobBoard
  // );

  const isMalaysia = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";
  const externalJBList = isMalaysia ? content_my : content_sg;

  const jBList = externalJBList?.map((item) => {
    return {
      id: item?.id,
      url: item?.jobBoardLogo?.data?.attributes?.url,
    };
  });

  return (
    <SectionContainer id="logo-carousel">
      <BoxStyled
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        gap={isTablet ? "40px" : "32px"}
        alignSelf={"stretch"}
      >
        <TextStyled
          fontSize={"24px"}
          fontWeight={"500"}
          lineHeight={"28.8px"}
          textAlign={"center"}
          fontFamily={"Inter"}
        >
          Your jobs will also be featured on:
        </TextStyled>

        <BoxContainer
          gap={"40px"}
          justifyContent={"center"}
          alignItems={"center"}
          flexWrap={"wrap"}
        >
          {jBList?.map((featuredMedia, index) => {
            return (
              <ImageStyled
                key={index}
                src={featuredMedia?.url}
                height={index === 3 ? "48px" : index === 5 ? "30px" : "38px"}
              />
            );
          })}
        </BoxContainer>
      </BoxStyled>
    </SectionContainer>
  );
}

export default EmployerLandingAggregator;
